export default class Model {
  constructor(makeMobxStore, _) {
    this._ = _;
    this.reset = makeMobxStore(this);
  }
  set = {
    clusterDoc: (clusterDoc = {}) => {
      this.clusterDoc = clusterDoc;
    },
    node: (node = {}) => {
      this.node = node;
    },
    readme: (readme = "") => {
      this.readme = readme;
    },
    json: (json = {}) => {
      this.json = json;
    },
    related: (related = []) => {
      this.related = related;
    },
    input: input => {
      this.input = input;
    },
    output: output => {
      this.output = output;
    },
    error: error => {
      this.error = error;
    },
    request: request => {
      this.request = request;
    },
    running: (running = false) => {
      this.running = running;
    }
  };
  getTier(ramRequired) {
    return ramRequired <= 24
      ? "free"
      : ramRequired <= 64
      ? "medium"
      : ramRequired <= 156
      ? "large"
      : "xl";
  }

  get tier() {
    return this.getTier(this.node.minRequiredCpuRamGB);
  }
  get freeTier() {
    return this.tier === "free";
  }
  get paidTier() {
    return this.tier === "medium";
  }
  get xlTier() {
    return this.tier === "large";
  }
  get customTier() {
    return this.tier === "xl";
  }
  get notOnApiPlan() {
    return this._.user.plan?.startsWith("models-api") !== true;
  }
  get onFreeApiPlan() {
    return this._.user.plan === "models-api-free";
  }
  get onPaidApiPlan() {
    return this._.user.plan === "models-api-10";
  }
  get onScalePlan() {
    return this._.user.plan === "models-api-50";
  }
  get allowed() {
    return this.notOnApiPlan || this.customTier
      ? false
      : this.freeTier ||
          (this.paidTier && this.onFreeApiPlan === false) ||
          (this.xlTier && this.onScalePlan);
  }
  get needsUpgrade() {
    return (
      (this.onFreeApiPlan && this.freeTier === false) ||
      (this.xlTier && this.onScalePlan === false)
    );
  }
}
